<template>
  <aside class="navbar">
    <div class="navbar_nav">
      <div class="navbar_item ">
        <router-link to="/" class="base_link logo">Divine-World</router-link>
      </div>
      <div class="navbar_item" v-if="!$store.getters.isAuth">
        <router-link to="/login" class="base_link">Авторизация</router-link>
      </div>
      <div class="navbar_item" v-else>
        <router-link to="/lk" class="base_link">Личный кабинет</router-link>
      </div>
      <div class="navbar_item">
        <router-link to="/downloads" class="download_button base_link">Скачать лаунчер</router-link>
      </div>
    </div>
  </aside>
</template>
<script>
export default {
  name: 'navbar',
  data() {
    return {};
  },
  methods: {},
  computed: {
    onTop() {
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/variables.scss";
.navbar{
  position: absolute;
  width: 100%;
  z-index: 3;
  background: linear-gradient(to top, transparent, rgba($color: $black, $alpha: 0.38));
  &_nav{
    height: 80px;
    padding: 0 40px;
    display: flex;
    align-items: center;
    width: 100%;
  }
  &_item{
    &:first-child{
      margin-right: auto;
    }
    font-family: $font;
    color: white;
    font-size: 18px;
    margin-right: 20px;
    &:last-child{
      margin-right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue